'use client';

import { mergePropsClassName } from '@liquorice/allsorts-craftcms-nextjs';
import React from 'react';
import { useTranslations } from 'use-intl';
import Btn, { BtnComponent, BtnProps } from '../ui/Btn';
import * as style from './Card.css';
import { useCard } from './useCard';

export type CardCtaProps<D extends React.ElementType = 'button'> = BtnProps<D>;

export const CardCta: BtnComponent = <D extends React.ElementType>({
  children,
  ...props
}: CardCtaProps<D>) => {
  const t = useTranslations('actions');
  const { customText } = useCard();

  return (
    <Btn variant="text" color="black" underline="always" {...mergePropsClassName(props, style.cta)}>
      {children || customText || t('readMore')}
    </Btn>
  );
};
